import { useNavigate } from 'react-router';
import { googleOauthClientId } from '@gonfalon/constants/constants';
import { isGithubOAuthSignUpEnabled, isGoogleOAuthSignUpEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import { Github } from '@gonfalon/icons/Github';
import { Message } from '@gonfalon/messages/Message';

import {
  GoogleDataText,
  GoogleOAuthButton,
} from '#components/loginAndSignUp/OAuthButtons/GoogleOAuthButton/GoogleOAuthButton';
import { DividerWithText } from '#components/ui/DividerWithText/DividerWithText';
import { trackLoginForm } from '#utils/loginUtils';

import styles from './OAuthButtons.module.css';

type OAuthButtonsProps = {
  /** Google OAuth pre-flow full-page navigation target (UTMs, agent-control post-signup). */
  oauthRedirectPath?: string;
};

export const OAuthButtons = ({ oauthRedirectPath = '/signup' }: OAuthButtonsProps) => {
  const googleClientId = googleOauthClientId();
  const isGoogleOAuthSignUpVisible = isGoogleOAuthSignUpEnabled() && !!googleClientId;
  const isGithubOAuthSignUpVisible = isGithubOAuthSignUpEnabled();
  const navigate = useNavigate();

  if (!isGoogleOAuthSignUpVisible && !isGithubOAuthSignUpVisible) {
    return null;
  }

  return (
    <section>
      <div className={styles.root}>
        {isGoogleOAuthSignUpVisible && (
          <div className={styles.googleButton}>
            <GoogleOAuthButton
              onClick={() => {
                void navigate(oauthRedirectPath);
              }}
              clientId={googleClientId}
              dataText={GoogleDataText.SIGNUP_WITH}
              theme="outline"
              logoAlignment="center"
            />
          </div>
        )}
        {isGithubOAuthSignUpVisible && (
          <div className={styles.githubButton}>
            <a
              href="oauth/github"
              onClick={() => {
                trackLoginForm('Github OAuth Button Clicked');
              }}
            >
              <span className={styles.githubButtonText}>
                <Github size="medium" className={styles.icon} /> <Message id="signUp.signUpForm.githubButton" />
              </span>
            </a>
          </div>
        )}
      </div>
      <div className={styles.divider}>
        <DividerWithText text="or" />
      </div>
    </section>
  );
};
